import React, { useEffect } from "react";
import { CheckCircle, XCircle, X } from "lucide-react";
import "../styling/flashmessage.css";

const FlashMessage = ({
  message,
  type = "success",
  duration = 5000,
  onClose,
}) => {
  useEffect(() => {
    if (!message) return;

    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <div className={`flash-message ${type}`}>
      <div className="flash-left">
        {type === "success" ? <CheckCircle size={18} /> : <XCircle size={18} />}
        <span className="flash-text">{message}</span>
      </div>

      <button className="flash-close" onClick={onClose}>
        <X size={16} />
      </button>
    </div>
  );
};

export default FlashMessage;
